<app-informate-sub-header [headerData]="subHeaderData" [calcOutput]="calculationResult"></app-informate-sub-header>
<div class="row" style="margin: 0 auto">
    <div class="col-lg-3 pb-7">
        <div cssClass="gutter-b card-stretch">
            <div class="card card-custom" [ngClass]="cssClass">
                <!--begin::Header-->
                <div class="card-header border-0 card-mobile-text pd-left-right-15" *ngIf="isInitialFormLoad">
                    <h3 class="card-title font-weight-bolder text-dark mt-8 mb-5 font-size-20">
                        <!-- Start a new Engineered Joint Calculation -->
                            {{ 'STANDARD_FLANGE_PAGE.LABELS.START_NEW' | transloco }}
                    </h3>

                    <div class="divFullwidth">
                        <a href="javascript:void(0)" class="btn primary-ebtn font-weight-bold py-3 px-6 w-100"
                            (click)="beginform()" #beginbtn>
                            <!-- Save inputs as default -->
                            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.BEGIN' | transloco }}
                        </a>
                    </div>
                </div>

                <div class="card-body p-2 informate-expansion-wrapper">
                    <mat-expansion-panel #panel1 [disabled]="true" [expanded]="tighteningform" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel1()">
                            <mat-panel-title>
                                {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.CONTROL_TIGHTENING_PROCEDURE' | transloco }}
                                <a href="javascript:void(0)" (click)="showPanel1()" *ngIf="editpanel_1"
                                    class="edit_icon" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-tightening-procedure-input [isRedirect]="isRedirect"
                            (returnData)="tighteningDataHandler($event)"></app-tightening-procedure-input>
                    </mat-expansion-panel>

                    <mat-expansion-panel #panel2 [disabled]="true" [expanded]="enggJointform" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel2()">
                            <mat-panel-title>
                                <!-- Engineered Joint -->
                                {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.ENGINEERED_JOINT' | transloco }}
                                <a href="javascript:void(0)" *ngIf="editpanel_2" class="edit_icon"
                                    (click)="showPanel2()" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-engineered-joint-input [isRedirect]="isRedirect" (returnData)="engJointDataHandler($event)"
                            (diagram)="diagramDataHandler($event)"></app-engineered-joint-input>
                    </mat-expansion-panel>

                    <mat-expansion-panel #panel3 [disabled]="true" [expanded]="toolsform" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel3()">
                            <mat-panel-title>
                                <!-- Tool Selection -->
                                {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.TOOL_SELECTION' | transloco }}
                                <a href="javascript:void(0)" *ngIf="editpanel_3" class="edit_icon"
                                    (click)="showPanel3()" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-tools-input [isRedirect]="isRedirect" [tools]="toolsData"
                            (nearestObst)="toolsDataHandler($event)" (selectedTool)="selectedToolDataHandler($event)"
                            (diagram)="diagramDataHandler($event)"></app-tools-input>
                    </mat-expansion-panel>

                    <div class="calculation_btn">
                        <button class="btn primary-ebtn py-3 px-6 w-100" [disabled]="
                                !isEngiFormValid ||
                                !isTighFormValid ||
                                engineerJointInputFormGroup?.invalid ||
                                tighteningProcedureForm?.invalid ||
                                toolsFormGroup?.invalid
                            " (click)="btnCalculateClicked()">
                            <!-- Calculate -->
                            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CALCULATE' | transloco }}
                        </button>
                    </div>
                </div>
                <!--end: Card Body-->
            </div>
        </div>
    </div>
    <div class="col-lg-9">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body">
                <mat-tab-group class="tab-wrapper" [(selectedIndex)]="outputTabIndex">
                    <mat-tab label="{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAMS' | transloco }}">
                        <div class="card-body custom-wrapper row section-scroll height-800" style="width: 100%">
                            <app-diagrams [isRedirect]="isRedirect" [diagramInfo]="diagramInfo"
                                [calcOutput]="calculationResult" (diagram)="diagramDataHandler($event)"
                                style="width: 100%"></app-diagrams>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_OUTPUT' | transloco }}">
                        <div class="card-body custom-wrapper row section-scroll height-800" style="width: 100%">
                            <app-warning-output class="col-md-12" [calcOutput]="calculationResult"></app-warning-output>
                            <div class="col-xl-6 col-lg-12" *ngIf="calculationResult?.calculationSucceeded">
                                <app-calculation-output [calcOutput]="calculationResult" [selectedTool]="selectedTool"
                                    style="width: 100%" (showAdvOptPanel)="showpanel()"
                                    *ngIf="calculationResult"></app-calculation-output>
                            </div>
                            <div class="col-xl-6 col-lg-12">
                                <app-stress-factors-output
                                    *ngIf="calculationResult?.calculationSucceeded && diagramInfo"
                                    [diagramInfo]="diagramInfo" [calcOutput]="calculationResult"
                                    style="width: 100%"></app-stress-factors-output>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
<div class="output-wrapper">
    <div *ngIf="hideAdvanceOptionTab == true">
        <div class="output-advance-option">
            <a href="javascript:void(0)" (click)="showpanel()">
                <p>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                    <!-- Advance outputs -->
                    {{ 'ADVANCED_OUTPUT.LABELS.ADVANCED_OUTPUT' | transloco }}
                </p>
            </a>
        </div>
        <app-advanced-output [showpaneltoggle]="showpaneltoggle" [calcOutput]="calculationResult"
            (hidepanel)="hidepanelclose()"></app-advanced-output>
    </div>
    <div>
        <div class="output-unit">
            <a href="javascript:void(0)" (click)="showUnitpanel()">
                <p>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                    <!-- Advance outputs -->
                    Units
                </p>
            </a>
        </div>
        <app-units [showPanelUnitToggle]="showPanelUnitToggle" (hideUnitpanel)="hideUnitpanelClose()"></app-units>
    </div>
</div>